class NewsletterModal extends ModalElement {
  constructor() {
    super();

    // Prevent popup on Shopify robot challenge page
    if (window.location.pathname === '/challenge' || !theme.cookiesEnabled) {
      return;
    }

    if (!theme.config.isTouch || Shopify.designMode) {
      this.init();
    }
    else {
      new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
    }

    // 初始化滚动监听
    this.initScrollListener();
  }

  get shouldLock() {
    return true;
  }

  get testMode() {
    return this.getAttribute('data-test-mode') === 'true';
  }

  get delay() {
    return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
  }

  get expiry() {
    return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 30;
  }

  get cookieName() {
    return 'concept:newsletter-popup';
  }

  get submited() {
    return this.querySelector('.alert') !== null;
  }

  init() {
    if (this.initialized) return;
    this.initialized = true;
    
    // Open modal if errors or success message exist
    if (this.submited) {
      this.load(1);
      return;
    }

    if (this.testMode || !this.getCookie(this.cookieName)) {
      this.load(this.delay);
    }
  }

  load(delay) {
    if (Shopify.designMode) return;
    
    // 如果 delay 为 -1，则不自动弹出
    if (delay === -1) return;

    setTimeout(() => this.show(), delay * 1000);
  }

  afterShow() {
    super.afterShow();
    this.classList.add('show-image');
  }

  afterHide() {
    super.afterHide();
    this.classList.remove('show-image');

    // Remove a cookie in case it was set in test mode
    if (this.testMode) {
      this.removeCookie(this.cookieName);
      return;
    }

    this.setCookie(this.cookieName, this.expiry);
  }

  getCookie(name) {
    const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return match ? match[2] : null;
  }

  setCookie(name, expiry) {
    document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
  }

  removeCookie(name) {
    document.cookie = `${name}=; max-age=0`;
  }

  initScrollListener() {
    let lastScrollTop = 0;
    const newsletterBar = document.querySelector('.newsletter-bar');
    if (!newsletterBar) return;
    
    // 检查是否设置了 mobile_disabled
    const isMobileDisabled = newsletterBar.classList.contains('hidden md:grid');
    
    // 创建媒体查询对象
    const mobileMediaQuery = window.matchMedia('(max-width: 767px)');
    
    // 处理滚动事件的函数
    const handleScroll = () => {
      // 如果在移动设备上且设置了 mobile_disabled，则不处理滚动
      if (isMobileDisabled && mobileMediaQuery.matches) {
        return;
      }
      
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollDirection = scrollTop > lastScrollTop ? 'down' : 'up';
      
      if (scrollDirection === 'down') {
        newsletterBar.classList.add('slide-out');
        // 添加一个短暂延迟，确保元素完全隐藏
        setTimeout(() => {
          if (newsletterBar.classList.contains('slide-out')) {
            newsletterBar.style.visibility = 'hidden';
          }
        }, 300); // 与 CSS 过渡时间匹配
      } else {
        newsletterBar.style.visibility = 'visible';
        // 短暂延迟后移除 slide-out 类，确保过渡效果正常
        setTimeout(() => {
          newsletterBar.classList.remove('slide-out');
        }, 10);
      }
      
      lastScrollTop = scrollTop;
    };

    // 添加滚动事件监听
    const throttledScrollHandler = theme.utils.throttle(handleScroll, 100);
    window.addEventListener('scroll', throttledScrollHandler);
    
    // 监听媒体查询变化
    mobileMediaQuery.addListener(() => {
      // 当媒体查询状态变化时，重新检查是否需要处理滚动
      if (isMobileDisabled && mobileMediaQuery.matches) {
        // 在移动设备上且设置了 mobile_disabled 时，确保元素可见
        newsletterBar.style.visibility = 'visible';
        newsletterBar.classList.remove('slide-out');
      }
    });
  }
}
customElements.define('newsletter-modal', NewsletterModal);
